module.exports = __webpack_public_path__ + "img/add.d1ec09b5.svg";